import {
  CREATE_AGREEMENT_FAILURE,
  CREATE_AGREEMENT_REQUEST,
  CREATE_AGREEMENT_SUCCESS,
  DECLINE_AGREEMENT_FAILURE,
  DECLINE_AGREEMENT_REQUEST,
  DECLINE_AGREEMENT_SUCCESS,
  FETCH_ADOBE_DOCUMENT_FAILURE,
  FETCH_ADOBE_DOCUMENT_REQUEST,
  FETCH_ADOBE_DOCUMENT_SIGNED_SUCCESS,
  FETCH_ADOBE_DOCUMENT_UNSIGNED_SUCCESS,
  FETCH_PDF_FAILURE,
  FETCH_PDF_REQUEST,
  FETCH_PDF_SUCCESS,
  INCREMENT_INTERVAL_COUNTER,
} from "../constants";

const INITIAL_STATE = {
  pdfUrl: "",
  adobeDocumentUrl: "",
  agreementId: "",
  isLoading: false,
  isDocumentSigned: false,
  intervalCounter: 0,
};

const storageDocumentReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_PDF_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_PDF_FAILURE:
      return {
        ...state,
        isLoading: false,
        pdfUrl: "",
      };
    case FETCH_PDF_SUCCESS:
      return {
        ...state,
        pdfUrl: action.payload.url,
        isLoading: false,
      };
    case CREATE_AGREEMENT_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case CREATE_AGREEMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        agreementId: "",
      };
    case CREATE_AGREEMENT_SUCCESS:
      return {
        ...state,
        agreementId: action.payload,
        isLoading: false,
      };
    case FETCH_ADOBE_DOCUMENT_REQUEST:
      return {
        ...state,
        isLoading: true,
        adobeDocumentUrl: "",
      };
    case FETCH_ADOBE_DOCUMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        adobeDocumentUrl: "",
        isDocumentSigned: false,
      };
    case FETCH_ADOBE_DOCUMENT_UNSIGNED_SUCCESS:
      return {
        ...state,
        isLoading: false,
        adobeDocumentUrl:
          action?.payload?.response?.participant?.[0]?.signingUrl,
        isDocumentSigned: false,
      };
    case FETCH_ADOBE_DOCUMENT_SIGNED_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isDocumentSigned: true,
        adobeDocumentUrl: "",
      };
    case INCREMENT_INTERVAL_COUNTER:
      return {
        ...state,
        intervalCounter: action.payload,
      };
    case DECLINE_AGREEMENT_REQUEST:
      return {
        isLoading: true,
      };
    case DECLINE_AGREEMENT_SUCCESS:
    case DECLINE_AGREEMENT_FAILURE:
      return {
        isLoading: false,
      };
    default:
      return state;
  }
};

export default storageDocumentReducer;
